import { FaCheckCircle } from 'react-icons/fa';
import { LiaSyncSolid } from 'react-icons/lia';
import { MdError } from 'react-icons/md';
import { cn } from '@/core/ui';

export const OperationStates = (props: React.ComponentProps<'div'>) => {
  return (
    <div {...props}>
      {/* <span className=''>States:</span> */}
      <span className='flex flex-row items-center space-x-2'>
        <LiaSyncSolid className={cn('w-6 h-6')} />
        <span className='text-sm'>Idle</span>
      </span>
      <span className='flex flex-row items-center space-x-2'>
        <LiaSyncSolid className={cn('w-6 h-6 animate-spin text-primary-800')} />
        <span className='text-sm'>Loading</span>
      </span>
      <span className='flex flex-row items-center space-x-2'>
        <FaCheckCircle className={cn('w-6 h-6 text-success-500')} />
        <span className='text-sm'>Success</span>
      </span>
      <span className='flex flex-row items-center space-x-2'>
        <MdError className={cn('w-6 h-6 text-danger-500')} />
        <span className='text-sm'>Error</span>
      </span>
    </div>
  );
};
